import { render } from "./FinesPoints.vue?vue&type=template&id=a11c572e&scoped=true"
import script from "./FinesPoints.vue?vue&type=script&lang=js"
export * from "./FinesPoints.vue?vue&type=script&lang=js"

import "./FinesPoints.vue?vue&type=style&index=0&id=a11c572e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11c572e"]])

export default __exports__